import {
    BADGE_CLASS,
    BADGE_ENTRIES_CLASS,
    BADGE_HOVER_CLASS,
    BADGE_MULTIPLIER_CLASS,
    BADGE_PULSE_CLASS,
    BADGE_QTY_PULSE_CLASS,
    BADGE_VISIBLE_CLASS,
    HOVER_BOUND_ATTR,
} from './constants';
import { formatEntries } from './helpers';

function getHoverTarget(container) {
    const directHost = container.closest('.card, .listItem, .productCarousel-slide');

    if (directHost) {
        return directHost;
    }

    let current = container.parentElement;

    while (current && current !== document.body) {
        if (current.querySelector('img, picture')) {
            return current;
        }

        current = current.parentElement;
    }

    return container.parentElement;
}

export function bindHoverState(container, badge) {
    const hoverTarget = getHoverTarget(container);

    if (!hoverTarget || hoverTarget.hasAttribute(HOVER_BOUND_ATTR)) {
        return;
    }

    hoverTarget.addEventListener('mouseenter', () => {
        badge.classList.add(BADGE_HOVER_CLASS);
    });

    hoverTarget.addEventListener('mouseleave', () => {
        badge.classList.remove(BADGE_HOVER_CLASS);
    });

    hoverTarget.setAttribute(HOVER_BOUND_ATTR, 'true');
}

export function createBadgeElement(source) {
    const badge = document.createElement('div');
    const entries = document.createElement('span');
    const multiplier = document.createElement('span');

    badge.className = BADGE_CLASS;
    badge.dataset.badgeSource = source;

    entries.className = BADGE_ENTRIES_CLASS;
    multiplier.className = BADGE_MULTIPLIER_CLASS;

    badge.appendChild(entries);
    badge.appendChild(multiplier);

    return badge;
}

export function setBadgeContent(badge, badgeData) {
    const entries = badge.querySelector(`.${BADGE_ENTRIES_CLASS}`);
    const multiplier = badge.querySelector(`.${BADGE_MULTIPLIER_CLASS}`);

    if (!entries || !multiplier || !badgeData) {
        return;
    }

    entries.textContent = badgeData.entriesText || `${formatEntries(badgeData.totalEntries)} TOTAL ENTRIES`;
    multiplier.textContent = '';
    multiplier.hidden = true;
}

export function revealBadge(badge, { pulse = true, animate = true } = {}) {
    if (badge.dataset.badgeReady === 'true') {
        return;
    }

    badge.dataset.badgeReady = 'true';

    if (animate) {
        requestAnimationFrame(() => {
            badge.classList.add(BADGE_VISIBLE_CLASS);

            if (pulse) {
                window.setTimeout(() => {
                    badge.classList.add(BADGE_PULSE_CLASS);
                }, 420);
            }
        });
    } else {
        badge.classList.add(BADGE_VISIBLE_CLASS);
    }
}

export function pulseBadgeForQuantityChange(badge) {
    if (!badge) {
        return;
    }

    badge.classList.remove(BADGE_QTY_PULSE_CLASS);
    void badge.offsetWidth;
    badge.classList.add(BADGE_QTY_PULSE_CLASS);
}
